import React from 'react';
import { FilterTagButton } from './FilterTagButton';

interface WorkspaceFilterPanelProps {
    allTags: string[];
    selectedTags: string[];
    onTagToggle: (tag: string) => void;
    onClearAll: () => void;
    className?: string;
}

/**
 * Reusable workspace filter panel component
 * Provides consistent tag filtering UI across workspace modals
 */
export const WorkspaceFilterPanel: React.FC<WorkspaceFilterPanelProps> = ({
                                                                              allTags,
                                                                              selectedTags,
                                                                              onTagToggle,
                                                                              onClearAll,
                                                                              className = '',
                                                                          }) => {
    return (
        <div className={`bg-white rounded-lg p-4 space-y-3 border ${className}`}>
            {/* Header */}
            <div className="flex items-center justify-between">
                <h4 className="text-sm font-medium text-gray-700">Filter by Tags</h4>
                {selectedTags.length > 0 && (
                    <button
                        onClick={onClearAll}
                        className="text-xs text-blue-600 hover:text-blue-800 font-medium"
                    >
                        Clear all
                    </button>
                )}
            </div>

            {/* Tag list */}
            {allTags.length > 0 ? (
                <div className="flex flex-wrap gap-2">
                    {allTags.map((tag) => (
                        <FilterTagButton
                            key={tag}
                            tag={tag}
                            selected={selectedTags.includes(tag)}
                            onToggle={onTagToggle}
                        />
                    ))}
                </div>
            ) : (
                <p className="text-sm text-gray-500">No tags found in your workspaces</p>
            )}
        </div>
    );
};

export default WorkspaceFilterPanel;
